import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/en/services/lab-services/method-development")({
  head: () => buildRouteHead("/en/services/lab-services/method-development"),
  component: LabOffering,
});

